import { render, staticRenderFns } from "./MatchResultList.vue?vue&type=template&id=5087c1b2&scoped=true&"
import script from "./MatchResultList.vue?vue&type=script&lang=js&"
export * from "./MatchResultList.vue?vue&type=script&lang=js&"
import style0 from "./MatchResultList.vue?vue&type=style&index=0&id=5087c1b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087c1b2",
  null
  
)

export default component.exports